import {apiGet} from "../service/api";
import {useEffect, useRef, useState} from "react";

/***
 * Created on 2024/2/20
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

export function useQnapAuthAppBindCheck(start) {
    const [status, setStatus] = useState("");
    const [device, setDevice] = useState();
    const [passcode, setPasscode] = useState();
    let intervalId = useRef();

    const checkBind = async () => {
        let result;
        try {
            result = await apiGet('/ajax/qnap_auth/bind/check');
        } catch (err) {
            result = {
                status: 'failed',
                error: err
            }
        }
        return result;
    }

    useEffect(() => {
        if (start) {
            intervalId.current = setInterval(async () => {
                const result = await checkBind();
                if (result.status === 'valid') {
                    clearInterval(intervalId.current);
                    setDevice(result.device);
                    setStatus(result.status);
                } else if (result.status === 'failed') {
                    setStatus('failed');
                } else {
                    setStatus(result.status);
                    if (result?.passcode) {
                        setPasscode(result?.passcode);
                    }
                }
            }, 2000);
        }

        return () => clearInterval(intervalId.current);
    }, [start]);

    return {status, device, passcode}
}